/* cSpell:ignore longpress animationend KHTML */

export const IEGoto = () => {
    let isIE = detectIE();
    console.log('isIE', isIE);

    if (isIE != false && isIE < 10) {
        alert('IE浏览器过于老旧，不再支持。请使用现代浏览器访问! 点击确定跳转。');
        window.location.href = "//zhuzhou.city/ieNeedUpdate/zh-cn/";
    }
};

function browserDifferenceHandle() {
    // 浏览器差异
    // UC 左右滑动 长按菜单
    if (navigator.control && navigator.control.gesture) {
        navigator.control.gesture(false);
    }

    if (navigator.control && navigator.control.longpressMenu) {
        navigator.control.longpressMenu(false);
    }

    animationHandle();

    console.blue = function (...args) {
        return console.log(`%c ${args.join(' | ')} `, "color:#fff;background:#7986cb");
    };
    console.red = function (...args) {
        return console.log(`%c ${args.join(' | ')} `, "color:#fff;background:#fe6767");
    };
    console.green = function (...args) {
        return console.log(`%c ${args.join(' | ')} `, "color:#fff;background:#67C23A");
    };
}
browserDifferenceHandle();

export const browserInfo = {
    versions: function () {
        let u = navigator.userAgent,
            app = navigator.appVersion; // eslint-disable-line
        return { //移动终端浏览器版本信息
            trident: u.indexOf('Trident') > -1, //IE内核
            presto: u.indexOf('Presto') > -1, //opera内核
            webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
            iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQ HD浏览器
            iPad: u.indexOf('iPad') > -1, //是否iPad
            webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
            weixin: !!u.match(/MicroMessenger/i),
        };
    }(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase(),
};


export const imgPreload = () => {
    // 图片预加载
    const imgs = [
        "./static/img/pano_loading.gif",
        "./static/img/pano_default.png",
    ];
    for (let i = 0; i < imgs.length; i++) {
        let imgObj = new Image(); // 创建图片对象
        imgObj.src = imgs[i];
        // 这里没有考虑error，实际上要考虑
        // eslint-disable-next-line
        imgObj.addEventListener('load', e => { }, false);
    }
};

export const getAnimationEvent = () => {
    // 判断事件
    let div = document.createElement('div'),
        style = div.style,
        animationNames = ['animation', 'WebkitAnimation', 'OAnimation', 'msAnimation', 'MozAnimation'],
		/**
		 * 通过style对象获取正确的 animation 名称
		 * @return { String || Boolean }  animation 名称
		 */
        animationName = (function () {
            let i = 0,
                len = animationNames.length,
                name,
                u;
            for (; i < len; i++) {
                name = animationNames[i];
                if (style[name] !== u) return name;
            }
            return false;
        })(),
        //真实的animationend
        aniEndName = {
            animation: 'animationend',
            WebkitAnimation: 'webkitAnimationEnd',
            OAnimation: 'oAnimationEnd',
            msAnimation: 'MSAnimationEnd',
            MozAnimation: 'mozAnimationEnd',
        }[animationName];
    div = style = animationNames = animationName = null;
    return aniEndName;
};



function animationHandle() {
    let lastTime = 0;
    let vendors = ['webkit', 'moz'];
    for (let x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || // Webkit中此取消方法的名字变了
            window[vendors[x] + 'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame) {
        window.requestAnimationFrame = function (callback, element) {
            let currTime = new Date().getTime();
            let timeToCall = Math.max(0, 16.7 - (currTime - lastTime));
            let id = window.setTimeout(() => {
                callback(currTime + timeToCall);
            }, timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
    }
    if (!window.cancelAnimationFrame) {
        window.cancelAnimationFrame = function (id) {
            clearTimeout(id);
        };
    }
}



function detectIE() {
    let ua = window.navigator.userAgent;
    let msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }
    let trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        let rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }
    // var edge = ua.indexOf('Edge/');
    // if (edge > 0) {
    //   // Edge (IE 12+) => return version number
    //   return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    // }
    // other browser
    return false;
}
